<div class="agendamentos-topo">
  <h1 class="agendamentos-titulo">
    Meus agendamentos
    <span class="agendamentos-enfeites" aria-hidden="true">
      <span class="agendamentos-enfeite agendamentos-enfeite-amarelo"></span>
      <span class="agendamentos-enfeite agendamentos-enfeite-triangulo"></span>
      <span class="agendamentos-enfeite agendamentos-enfeite-azul"></span>
    </span>
  </h1>

  <p class="agendamentos-subtitulo">
    Atendimentos que você marcou.
    @if (totalProximos()) {
      <strong>{{ totalProximos() }}</strong>
      {{ totalProximos() === 1 ? 'ainda vai acontecer.' : 'ainda vão acontecer.' }}
    }
  </p>
</div>

@switch (estado()) {
  @case ('sessao') {
    <div class="agendamentos-aviso" role="status">
      <span class="agendamentos-aviso-icone" aria-hidden="true">
        <i-lucide name="log-in" size="18"></i-lucide>
      </span>

      <div>
        <p class="agendamentos-aviso-titulo">Sua sessão foi encerrada.</p>
        <p class="agendamentos-aviso-texto">
          Entre novamente para ver seus agendamentos.
          <a class="agendamentos-aviso-link" routerLink="/login">Entrar</a>
        </p>
      </div>
    </div>
  }

  @case ('carregando') {
    <p class="agendamentos-carga" role="status" aria-live="polite">
      <i-lucide name="loader-circle" size="18" aria-hidden="true"></i-lucide>
      Carregando seus agendamentos...
    </p>
  }

  @case ('falha') {
    <div class="agendamentos-aviso agendamentos-aviso-erro" role="alert">
      <span class="agendamentos-aviso-icone" aria-hidden="true">
        <i-lucide name="circle-alert" size="18"></i-lucide>
      </span>

      <div class="agendamentos-aviso-conteudo">
        <p class="agendamentos-aviso-titulo">Não foi possível carregar seus agendamentos.</p>
        <button type="button" class="agendamentos-botao" (click)="tentarNovamente()">Tentar novamente</button>
      </div>
    </div>
  }

  @case ('pronto') {
    @if (semAgendamentos()) {
      <div class="agendamentos-vazio">
        <span class="agendamentos-vazio-icone" aria-hidden="true">
          <i-lucide name="calendar-x" size="32"></i-lucide>
        </span>

        <p class="agendamentos-vazio-texto">Você ainda não tem agendamentos.</p>
      </div>
    } @else {
      <section class="agendamentos-filtros" aria-label="Filtrar agendamentos">
        <div class="agendamentos-abas" role="group" aria-label="Situação">
          @for (opcao of situacoes; track opcao.id) {
            <button
              type="button"
              class="agendamentos-aba"
              [class.agendamentos-aba-ativa]="situacao() === opcao.id"
              [attr.aria-pressed]="situacao() === opcao.id"
              (click)="filtrarPor(opcao.id)"
            >
              {{ opcao.rotulo }}
            </button>
          }
        </div>

        <div class="agendamentos-selects">
          <label class="agendamentos-campo">
            <span>Serviço</span>
            <!-- A opção marcada vai em cada `<option>`: um `[value]` no `<select>` é aplicado antes
                 de o `@for` criar as opções, e o filtro voltaria a "Todos" ao recriar a lista. -->
            <select class="agendamentos-select" (change)="aoTrocarServico($event)">
              <option value="" [selected]="servico() === ''">Todos</option>
              @for (nome of servicos(); track nome) {
                <option [value]="nome" [selected]="nome === servico()">{{ nome }}</option>
              }
            </select>
          </label>
        </div>
      </section>

      @if (total()) {
        <ul class="agendamentos-lista">
          @for (item of lista(); track item.desProtocoloSsv) {
            <li
              class="agendamentos-item"
              [attr.data-situacao]="item.desSituacao"
            >
              <div class="agendamentos-quando">
                <span class="agendamentos-data">{{ dataDe(item) }}</span>
                <span class="agendamentos-hora">{{ horaDe(item) }}</span>
              </div>

              <div class="agendamentos-corpo">
                <div class="agendamentos-selos">
                  <!-- Fixo: todo agendamento é presencial. -->
                  <span class="agendamentos-modalidade-selo">
                    <i-lucide name="building-2" size="14" aria-hidden="true"></i-lucide>
                    Presencial
                  </span>

                  <span class="agendamentos-status" [attr.data-situacao]="item.desSituacao">
                    <i-lucide [name]="iconeSituacao(item.desSituacao)" size="14" aria-hidden="true"></i-lucide>
                    {{ item.desSituacao }}
                  </span>

                  @if (item.desCategoria) {
                    <span class="agendamentos-categoria">{{ item.desCategoria }}</span>
                  }
                </div>

                <h2 class="agendamentos-servico">{{ item.desNomeServicoSsv }}</h2>

                @if (item.desLocalAtendimentoSsv) {
                  <p class="agendamentos-local">
                    <i-lucide name="map-pin" size="16" aria-hidden="true"></i-lucide>
                    {{ item.desLocalAtendimentoSsv }}
                  </p>
                }

                <p class="agendamentos-protocolo">Protocolo: {{ item.desProtocoloSsv }} • {{ rotuloCidadao(item) }}</p>

                @if (prazoEncerrado(item)) {
                  <p class="agendamentos-prazo agendamentos-prazo-encerrado">
                    <i-lucide name="clock-alert" size="16" aria-hidden="true"></i-lucide>
                    O prazo para alterar ou cancelar pelo portal terminou. Procure o órgão responsável.
                  </p>
                }
              </div>

              <div class="agendamentos-acoes">
                <button type="button" class="agendamentos-botao" (click)="verDetalhes(item)">
                  <i-lucide name="eye" size="16" aria-hidden="true"></i-lucide>
                  Ver detalhes
                </button>

                @if (item.bitPodeReagendar) {
                  <button type="button" class="agendamentos-botao" (click)="reagendar(item)">
                    <i-lucide name="calendar-clock" size="16" aria-hidden="true"></i-lucide>
                    Reagendar
                  </button>
                }

                @if (item.bitPodeCancelar) {
                  <button
                    type="button"
                    class="agendamentos-botao agendamentos-botao-perigo"
                    [disabled]="cancelando()"
                    (click)="cancelar(item)"
                  >
                    <i-lucide name="circle-x" size="16" aria-hidden="true"></i-lucide>
                    Cancelar
                  </button>
                }
              </div>
            </li>
          }
        </ul>
      } @else {
        <div class="agendamentos-vazio">
          <span class="agendamentos-vazio-icone" aria-hidden="true">
            <i-lucide name="calendar-x" size="32"></i-lucide>
          </span>

          <p class="agendamentos-vazio-texto">Nenhum agendamento para o filtro selecionado.</p>

          <button type="button" class="agendamentos-botao" (click)="filtrarPor('todos')">Ver todos</button>
        </div>
      }
    }
  }
}

<dialog #modalDetalhe class="agendamentos-modal" aria-labelledby="modal-agendamento-titulo">
  @if (selecionado(); as item) {
    <div class="agendamentos-modal-conteudo">
      <div class="agendamentos-modal-topo">
        <div>
          <h2 class="agendamentos-modal-titulo" id="modal-agendamento-titulo">Detalhes do agendamento</h2>
          <p class="agendamentos-modal-protocolo">Protocolo: {{ item.desProtocoloSsv }}</p>
        </div>

        <button type="button" class="agendamentos-modal-fechar" (click)="fecharDetalhes()" aria-label="Fechar">
          <i-lucide name="x" size="20" aria-hidden="true"></i-lucide>
        </button>
      </div>

      <dl class="agendamentos-modal-dados">
        <div>
          <dt>Serviço</dt>
          <dd>{{ item.desNomeServicoSsv }}</dd>
        </div>
        @if (item.desCategoria) {
          <div>
            <dt>Categoria</dt>
            <dd>{{ item.desCategoria }}</dd>
          </div>
        }
        <div>
          <dt>Modalidade</dt>
          <dd>Presencial</dd>
        </div>
        <div>
          <dt>Data e hora</dt>
          <dd>{{ dataDe(item) }} às {{ horaDe(item) }}</dd>
        </div>
        <div>
          <dt>Situação</dt>
          <dd>{{ item.desSituacao }}</dd>
        </div>
        <div>
          <dt>Cidadão</dt>
          <dd>{{ rotuloCidadao(item) }}</dd>
        </div>
        @if (item.desLocalAtendimentoSsv) {
          <div class="agendamentos-modal-dado-largo">
            <dt>Local de atendimento</dt>
            <dd>{{ item.desLocalAtendimentoSsv }}</dd>
          </div>
        }
      </dl>

      @for (aviso of avisosDePrazo(item); track $index) {
        <p class="agendamentos-prazo" [class.agendamentos-prazo-encerrado]="prazoEncerrado(item)">
          <i-lucide [name]="prazoEncerrado(item) ? 'clock-alert' : 'clock'" size="16" aria-hidden="true"></i-lucide>
          {{ aviso }}
        </p>
      }

      @if (item.desMotivoCancelamentoSsv) {
        <p class="agendamentos-modal-cancelamento">
          <i-lucide name="circle-x" size="16" aria-hidden="true"></i-lucide>
          <span>
            <strong>{{ item.bitCanceladoPeloOrgao ? 'Motivo informado pelo órgão:' : 'Motivo do cancelamento:' }}</strong>
            {{ item.desMotivoCancelamentoSsv }}
          </span>
        </p>
      }

      @if (linhaDoTempo().length) {
        <div class="agendamentos-modal-secao">
          <h3 class="agendamentos-modal-subtitulo">Linha do tempo</h3>

          <ol class="agendamentos-linha">
            @for (evento of linhaDoTempo(); track $index) {
              <li class="agendamentos-linha-item" [attr.data-tom]="evento.tom">
                <span class="agendamentos-linha-marca" aria-hidden="true"></span>

                <span class="agendamentos-linha-rotulo">{{ evento.rotulo }}</span>
                <span class="agendamentos-linha-quando">{{ evento.quando }}</span>
                <p class="agendamentos-linha-descricao">{{ evento.descricao }}</p>
              </li>
            }
          </ol>
        </div>
      }

      <div class="agendamentos-modal-acoes">
        <button type="button" class="agendamentos-botao" (click)="fecharDetalhes()">
          <i-lucide name="arrow-left" size="16" aria-hidden="true"></i-lucide>
          Voltar
        </button>

        @if (item.bitPodeReagendar) {
          <button type="button" class="agendamentos-botao" (click)="reagendar(item)">
            <i-lucide name="calendar-clock" size="16" aria-hidden="true"></i-lucide>
            Reagendar agendamento
          </button>
        }

        @if (item.bitPodeCancelar) {
          <button
            type="button"
            class="agendamentos-botao agendamentos-botao-perigo"
            [disabled]="cancelando()"
            (click)="cancelar(item)"
          >
            <i-lucide name="circle-x" size="16" aria-hidden="true"></i-lucide>
            Cancelar agendamento
          </button>
        }
      </div>
    </div>
  }
</dialog>

<app-modal-reagendamento (reagendado)="aoReagendar($event)" (recusado)="aoRecusarReagendamento($event)" />
